import React from 'react';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';

import { ReactComponent as Logo } from '../../assets/images/logo.svg';

import './style.scss';

const HeaderLogo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CoreLink href="/" className="SiteLogo" ariaLabel={t('components.site_logo.aria-label')}>
      <Logo />
    </CoreLink>
  );
};

export default HeaderLogo;
